<template>
  <div class="personal-page">
    <!-- <div class="left-menu">
      <div :class="`menu-item ${activeMenu.name === menu.name ? 'active' : ''}`" v-for="menu in curMenuList" :key="menu.name" @click="changeMenu(menu)">
        <span>{{ menu.label }}</span>
      </div>
    </div> -->
    <div class="content-container">
      <div class="top-title">
        <span>{{ activeMenu.title }}</span>
      </div>
      <ManagerInfo v-if="activeMenu.name === 'manager'" :user-info="userInfo" :manager-info="managerInfo" />
      <UserInfo v-if="activeMenu.name === 'accountAndSafe'" :user-info="userInfo"></UserInfo>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import ManagerInfo from './managerInfo.vue'

import UserInfo from "./userInfo.vue";
import tableMix from "@/components/common/tableListMixin.js";

export default {
  components: { ManagerInfo, UserInfo },
  mixins: [tableMix],
  ...mapActions(["fetchData"]),
  data() {
    return {
      menuList: [
        { name: 'accountAndSafe', label: '账号与安全', title: '个人中心' },
        { name: 'manager', label: '经营信息', title: '经营信息' },
      ],
      activeMenu: {},

      managerInfo: {}
    }
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.common.user,
    }),
    // 是经营者
    isManager() {
      let yes = this.userInfo.userType == 4
      if (yes && !this.managerInfo.id) {
        this.fetchData({
          url: "MANAGER.GET_LIST",
          params: { pageNumber: 1, pageSize: 20 },
        }).then((res) => {
          this.managerInfo = res.data[0];
          if (!this.managerInfo.id || this.managerInfo.reviewStatus == 4) {
            this.$message.warning('未填写经营者信息或已注销！')
            this.activeMenu = this.menuList[1]
          }
        });
      }
      return yes
    },
    // 当前菜单
    curMenuList() {
      if (this.isManager) {
        return this.menuList
      }
      return [this.menuList[0]]
    }
  },
  created() {
    const index = this.menuList.findIndex(e => e.name == this.$route.query.name);
    this.activeMenu = this.menuList[index == -1 ? 0 : index];
  },
  methods: {
    // 切换菜单
    changeMenu(menu) {
      this.activeMenu = menu
    }
  },
  watch: {
    $route(route){
      const index = this.menuList.findIndex(e => e.name == route.query.name);
      this.activeMenu = this.menuList[index == -1 ? 0 : index];
    }
  }
}
</script>

<style lang="less" scoped>
.personal-page {
  display: flex;
  padding-top: 10px;
  padding-bottom: 20px;
  width: 100%;
  height: 100%;
  .left-menu {
    padding-top: 20px;
    margin-right: 10px;
    width: 177px;
    height: 100%;
    background-color: white;
    border-radius: 5px;
  }
  .menu-item {
    position: relative;
    display: flex;
    align-items: center;
    padding: 12px 0px;
    padding-left: 25px;
    width: 100%;
    transition: background-color 200ms linear;
    cursor: pointer;
    &.active, &:hover {
      background-color: rgba(250, 246, 246, 1);
      &::before {
        content: "";
        position: absolute;
        left: 0px;
        width: 4px;
        height: 100%;
        background-color: rgba(246, 100, 1, 1);
      }
    }
  }
  .content-container {
    flex: 1;
    min-height: 100%;
    background-color: white;
    border-radius: 5px;
  }
  .top-title {
    padding: 21px 0px;
    padding-left: 66px;
    font-size: 24px;
    border-bottom: 1px solid rgba(240, 242, 245, 1);
  }
}
</style>